import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import { Collapse } from 'react-collapse';

import {
  toggleInstruction,
} from 'actions';

import HintButton from 'components/Common/Buttons/HintButton';
import HintPanel from 'components/Common/HintPanel';
import InstructionDefinition from 'components/InstructionDefinition';
import FormsInstructions from 'components/FormsInstructions';
import { RadioInput } from 'components/Common/Inputs/RadioInput';
import FieldChangeWrapper from 'components/Common/FieldChangeWrapper';

class RadioTableGroup extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.shape({}),
          PropTypes.string,
          PropTypes.node,
          PropTypes.arrayOf(PropTypes.node)
        ])
      )
    ).isRequired,
    normalize: PropTypes.func,
    onChange: PropTypes.func,
    className: PropTypes.string,
    preventReset: PropTypes.bool,
    /* eslint-disable react/no-unused-prop-types */
    hint: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    tip: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    caution: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    lineNumber: PropTypes.string,
    /* eslint-enable react/no-unused-prop-types */
    reverseInput: PropTypes.bool
  };

  static defaultProps = {
    normalize: null,
    onChange: null,
    className: '',
    preventReset: false,
    hint: '',
    tip: '',
    caution: '',
    lineNumber: '',
    reverseInput: false
  };

  defRefs = [];

  constructor(props) {
    super(props);
    this.state = {
      instructions: [
        { type: 'hint' },
        { type: 'tip' },
        { type: 'caution' }
      ],
      itemInstructions: {}
    };
  }

  showInstruction(hintType, hintText) {
    const { dispatch } = this.props;
    const { instructions } = this.state;
    this.setState({
      instructions: instructions != null && instructions
        .map(
          (instruction) => {
            if (instruction != null) {
              if (instruction.type === hintType) {
                instruction.text = hintText;
                instruction.visible = !instruction.visible;
              }
              return instruction;
            }
            return null;
          }
        )
    });
    dispatch(toggleInstruction());
  }

  showItemInstruction(
    rowIndex,
    cellIndex,
    hintType,
    hintText
  ) {
    const { dispatch } = this.props;
    const { itemInstructions } = this.state;
    const initialItemInstructions = [
      { type: 'hint' },
      { type: 'tip' },
      { type: 'caution' }
    ];
    this.setState({
      itemInstructions: {
        ...itemInstructions,
        [`${ rowIndex }-${ cellIndex }`]: itemInstructions[`${ rowIndex }-${ cellIndex }`] != null
          ? itemInstructions[`${ rowIndex }-${ cellIndex }`] && itemInstructions[`${ rowIndex }-${ cellIndex }`]
            .map(
              (instruction) => {
                if (instruction != null) {
                  if (instruction.type === hintType) {
                    instruction.text = hintText;
                    instruction.visible = !instruction.visible;
                  }
                  return instruction;
                }
                return null;
              }
            )
          : initialItemInstructions != null && initialItemInstructions
            .map(
              (instruction) => {
                if (instruction != null) {
                  if (instruction.type === hintType) {
                    instruction.text = hintText;
                    instruction.visible = !instruction.visible;
                  }
                  return instruction;
                }
                return null;
              }
            )
      }
    });
    dispatch(toggleInstruction());
  }

  hideInstruction(hintType) {
    const { dispatch } = this.props;
    const { instructions } = this.state;
    this.setState({
      instructions: instructions != null && instructions
        .map(
          (instruction) => {
            if (instruction != null) {
              if (instruction.type === hintType) {
                instruction.visible = false;
              }
              return instruction;
            }
            return null;
          }
        )
    });
    dispatch(toggleInstruction());
  }

  hideItemInstruction(
    rowIndex,
    cellIndex,
    hintType
  ) {
    const { dispatch } = this.props;
    const { itemInstructions } = this.state;
    const initialItemInstructions = [
      { type: 'hint' },
      { type: 'tip' },
      { type: 'caution' }
    ];
    this.setState({
      itemInstructions: {
        ...itemInstructions,
        [`${ rowIndex }-${ cellIndex }`]: itemInstructions[`${ rowIndex }-${ cellIndex }`] != null
          ? itemInstructions[`${ rowIndex }-${ cellIndex }`] != null && itemInstructions[`${ rowIndex }-${ cellIndex }`]
            .map(
              (instruction) => {
                if (instruction != null) {
                  if (instruction.type === hintType) {
                    instruction.visible = false;
                  }
                  return instruction;
                }
                return null;
              }
            )
          : initialItemInstructions != null && initialItemInstructions
            .map(
              (instruction) => {
                if (instruction != null) {
                  if (instruction.type === hintType) {
                    instruction.visible = false;
                  }
                  return instruction;
                }
                return null;
              }
            )
      }
    });
    dispatch(toggleInstruction());
  }

  showDefinition({ type: hintType }, definition) {
    const { dispatch } = this.props;
    const { instructions } = this.state;
    this.setState({
      instructions: instructions != null && instructions
        .map(
          (instruction, i) => {
            if (instruction != null) {
              if (!instruction.definitions) {
                instruction.definitions = [];
              }
              if (instruction.type === hintType) {
                const defIndex = instruction.definitions.findIndex(
                  def => def.name === definition
                );
                if (defIndex === -1) {
                  instruction.definitions = [
                    ...instruction.definitions,
                    { name: definition }
                  ];
                } else {
                  const defInstance = this.defRefs[`${ i }-${ defIndex }`];
                  if (defInstance) {
                    defInstance.highlight();
                  }
                }
              }
              return instruction;
            }
            return null;
          }
        )
    });
    dispatch(toggleInstruction());
  }

  showItemDefinition(
    rowIndex,
    cellIndex,
    { type: hintType },
    definition
  ) {
    const { dispatch } = this.props;
    const { itemInstructions } = this.state;
    const initialItemInstructions = [
      { type: 'hint' },
      { type: 'tip' },
      { type: 'caution' }
    ];
    this.setState({
      itemInstructions: {
        ...itemInstructions,
        [`${ rowIndex }-${ cellIndex }`]: itemInstructions[`${ rowIndex }-${ cellIndex }`] != null
          ? itemInstructions[`${ rowIndex }-${ cellIndex }`] != null && itemInstructions[`${ rowIndex }-${ cellIndex }`]
            .map(
              (instruction, i) => {
                if (instruction != null) {
                  if (!instruction.definitions) {
                    instruction.definitions = [];
                  }
                  if (instruction.type === hintType) {
                    const defIndex = instruction.definitions.findIndex(
                      def => def.name === definition
                    );
                    if (defIndex === -1) {
                      instruction.definitions = [
                        ...instruction.definitions,
                        { name: definition }
                      ];
                    } else {
                      const defInstance = this.defRefs[`${ i }-${ defIndex }`];
                      if (defInstance) {
                        defInstance.highlight();
                      }
                    }
                  }
                  return instruction;
                }
                return null;
              }
            )
          : initialItemInstructions != null && initialItemInstructions
            .map(
              (instruction, i) => {
                if (instruction != null) {
                  if (instruction.type === hintType) {
                    const defIndex = instruction.definitions.findIndex(
                      def => def.name === definition
                    );
                    if (defIndex === -1) {
                      instruction.definitions = [
                        ...instruction.definitions,
                        { name: definition }
                      ];
                    } else {
                      const defInstance = this.defRefs[`${ i }-${ defIndex }`];
                      if (defInstance != null) {
                        defInstance.highlight();
                      }
                    }
                  }
                  return instruction;
                }
                return null;
              }
            )
      }
    });
    dispatch(toggleInstruction());
  }

  hideDefinition(
    { type: hintType },
    { name: definition }
  ) {
    const { dispatch } = this.props;
    const { instructions } = this.state;
    this.setState({
      instructions: instructions != null && instructions
        .map(
          (instruction) => {
            if (instruction != null) {
              if (instruction.type === hintType) {
                instruction.definitions = instruction.definitions
                  .filter(def => def.name !== definition);
              }
              return instruction;
            }
            return null;
          }
        )
    });
    dispatch(toggleInstruction());
  }

  hideItemDefinition(
    rowIndex,
    cellIndex,
    { type: hintType },
    { name: definition }
  ) {
    const { dispatch } = this.props;
    const { itemInstructions } = this.state;
    const initialItemInstructions = [
      { type: 'hint' },
      { type: 'tip' },
      { type: 'caution' }
    ];
    this.setState({
      itemInstructions: {
        ...itemInstructions,
        [`${ rowIndex }-${ cellIndex }`]: itemInstructions[`${ rowIndex }-${ cellIndex }`] != null
          ? itemInstructions[`${ rowIndex }-${ cellIndex }`] != null && itemInstructions[`${ rowIndex }-${ cellIndex }`]
            .map(
              (instruction, i) => {
                if (instruction != null) {
                  if (instruction.type === hintType) {
                    instruction.definitions = instruction.definitions.filter(def => def.name !== definition);
                  }
                  return instruction;
                }
                return null;
              }
            )
          : initialItemInstructions != null && initialItemInstructions
            .map(
              (instruction, i) => {
                if (instruction != null) {
                  if (instruction.type === hintType) {
                    instruction.definitions = instruction.definitions.filter(def => def.name !== definition);
                  }
                  return instruction;
                }
                return null;
              }
            )
      }
    });
    dispatch(toggleInstruction());
  }

  render() {
    const {
      dispatch,
      name,
      items,
      normalize,
      onChange,
      className,
      preventReset,
      lineNumber,
      hint,
      tip,
      caution,
      reverseInput,
    } = this.props;
    const {
      itemInstructions
    } = this.state;
    let {
      instructions
    } = this.state;
    instructions = instructions != null ? instructions : [
      { type: 'hint' },
      { type: 'tip' },
      { type: 'caution' }
    ];
    instructions[0].text = hint;
    instructions[1].text = tip;
    instructions[2].text = caution;
    const activatedInstructions = instructions.filter(item => item.visible);
    const activatedInstructionTypes = activatedInstructions.map(instruction => instruction != null && instruction.type);
    return (
      /* eslint-disable max-len, react/no-array-index-key */
      <span id="radiotablegroupwrapper">
        <table
          className={ `radio-buttons-group table-group ${ className }` }
        >
          <tbody>
            { items != null && items
              .map((row, rowIndex) => (
                row != null
                && <tr key={ `key-${ name }-${ rowIndex }` }>
                  { row != null && row
                    .map((cell, cellIndex) => (
                      cell != null
                      && <td
                        rowSpan={ cell.rowSpan }
                        colSpan={ cell.colSpan }
                        key={ `key-${ name }-${ rowIndex }-${ cellIndex }` }
                        className={ `${ cell.className || '' }${ cell.beforeLabel ? ' with-before-label' : '' }` }
                        data-beforelabel={ cell.beforeLabel }
                      >
                        {
                          cell.text === undefined
                          && cell.value === undefined
                          && <span>&nbsp;</span>
                        }
                        { cell.text != null && cell.value === undefined && <div>
                          { cell.text }
                          { instructions != null && instructions.length > 0 && <span className="hintbuttonwrapper">
                            { instructions
                              .filter(instruction => instruction.type)
                              .map((instruction, i) => (
                                instruction != null
                                && instruction.text != null
                                && instruction.text !== ''
                                && <HintButton
                                  // eslint-disable-next-line react/no-array-index-key
                                  key={ `hint-button-${ i }` }
                                  hintType={ instruction.type }
                                  active={ activatedInstructionTypes.includes(instruction.type) }
                                  buttonBackground="#f6f8fe"
                                  onClick={
                                    () => this.showInstruction(
                                      instruction.type,
                                      instruction.text
                                    )
                                  }
                                />
                              )) }
                          </span> }
                        </div> }
                        { cell.text && cell.value !== undefined && <Field
                          name={ name }
                          component={ FieldChangeWrapper }
                          wrappedComponent={ RadioInput }
                          iValue={ `${ cell.value }` }
                          item={ cell.enableInstructions ? <div id="itemwrapper">
                            { cell.text }
                            <span className="hintbuttonwrapper">
                              {
                                instructions != null && instructions
                                  .filter(instruction => FormsInstructions[cell.form][`line${ cell.lineNumber }`][instruction.type])
                                  .map((instruction, i) => (
                                    instruction != null
                                    && instruction.text != null
                                    && instruction.text !== ''
                                    && <HintButton
                                      // eslint-disable-next-line react/no-array-index-key
                                      key={ `hint-button-${ i }` }
                                      hintType={ instruction.type }
                                      active={
                                        (itemInstructions[`${ rowIndex }-${ cellIndex }`]
                                        && itemInstructions[`${ rowIndex }-${ cellIndex }`]
                                          .filter(item => item.visible)
                                          .map(item => item != null && item.type)
                                          .includes(instruction.type)
                                        )
                                        || false
                                      }
                                      buttonBackground="#f6f8fe"
                                      onClick={
                                        () => this.showItemInstruction(
                                          rowIndex,
                                          cellIndex,
                                          instruction.type,
                                          FormsInstructions[cell.form][`line${ cell.lineNumber }`][instruction.type]
                                        )
                                      }
                                    />
                                  ))
                                }
                            </span>
                          </div> : cell.text }
                          normalize={ normalize }
                          onChange={ onChange }
                          reset={
                            (
                              formName,
                              inputName
                            ) => {
                              if (!preventReset) {
                                dispatch(change(
                                  formName,
                                  inputName,
                                  null
                                ));
                              }
                            }
                          }
                          reverseInput={ reverseInput }
                        /> }
                        { itemInstructions[`${ rowIndex }-${ cellIndex }`]
                          && <Collapse
                            isOpened={ cell.enableInstructions }
                            style={ { marginLeft: '-5rem' } }
                          >
                            {
                            itemInstructions[`${ rowIndex }-${ cellIndex }`]
                              .filter(item => item.visible)
                              .map((instruction, i) => (
                                instruction != null
                                && <div
                                  id="instructionwrapper"
                                  className="instruction-wrapper"
                                  // eslint-disable-next-line react/no-array-index-key
                                  key={ `hint-panel-${ i }` }
                                >
                                  <HintPanel
                                    hintType={ instruction.type }
                                    hintText={ FormsInstructions[cell.form][`line${ cell.lineNumber }`][instruction.type] }
                                    lineNumber={ cell.lineNumber }
                                    onSelectDefinition={ def => this.showItemDefinition(rowIndex, cellIndex, instruction, def) }
                                    onClose={ () => this.hideItemInstruction(rowIndex, cellIndex, instruction.type) }
                                  />
                                  { instruction.definitions && instruction.definitions
                                    .map((definition, j) => (
                                      definition != null
                                      && <HintPanel
                                          // eslint-disable-next-line react/no-array-index-key
                                        key={ `hint-panel-${ i }-${ j }` }
                                        ref={ (ref) => { this.defRefs[`${ i }-${ j }`] = ref; } }
                                        hintType="definition"
                                        hintText={
                                          <InstructionDefinition
                                            definition={ definition.name }
                                          />
                                          }
                                        onClose={ () => this.hideItemDefinition(rowIndex, cellIndex, instruction, definition) }
                                      />
                                    )) }
                                </div>
                              ))
                            }
                          </Collapse> }
                      </td>
                    )) }
                </tr>
              )) }
          </tbody>
        </table>
        <Collapse
          isOpened={ instructions.length > 0 }
          style={ { marginLeft: '-50px' } }
        >
          { activatedInstructions != null && activatedInstructions
            .map((instruction, i) => (
              instruction != null
              && <div
                id="instructionwrapper"
                className="instruction-wrapper"
                  // eslint-disable-next-line react/no-array-index-key
                key={ `hint-panel-${ i }` }
              >
                <HintPanel
                  hintType={ instruction.type }
                  hintText={ instruction.text }
                  lineNumber={ lineNumber }
                  onSelectDefinition={ def => this.showDefinition(instruction, def) }
                  onClose={ () => this.hideInstruction(instruction.type) }
                />
                { instruction.definitions != null && instruction.definitions
                  .map((definition, j) => (
                    definition != null
                    && <HintPanel
                          // eslint-disable-next-line react/no-array-index-key
                      key={ `hint-panel-${ i }-${ j }` }
                      ref={ (ref) => { this.defRefs[`${ i }-${ j }`] = ref; } }
                      hintType="definition"
                      hintText={
                        <InstructionDefinition
                          definition={ definition.name }
                        />
                          }
                      onClose={ () => this.hideDefinition(instruction, definition) }
                    />
                  )) }
              </div>
            ))}
        </Collapse>
      </span>
      /* eslint-enable max-len, react/no-array-index-key */
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  null,
  mapDispatchToProps
)(RadioTableGroup);
